import { render, staticRenderFns } from "./SectionWhatToStudy.component.vue?vue&type=template&id=2bb56bc4&"
import script from "./SectionWhatToStudy.component.vue?vue&type=script&lang=js&"
export * from "./SectionWhatToStudy.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports